<template>
    <v-container fluid>
        <material-card
        color="primary"
        title="Daftar Arsip Batch"
        class="card-wrapper"
        >
        <form>
            <esign-filter-panel>
            <div style="height: 80px" class="form-input row">
                <div v-if="peran!='A02'" class="col-3">
                <p class="label font-weight-bold mb-1">Username Pengaju</p>
                <v-text-field
                    v-model="searchFormBatch.username_pengaju"
                    placeholder="Username Pengaju"
                    dense
                    outlined
                />
                </div>
                <div v-if="peran!='A03'" class="col-3">
                <p class="label font-weight-bold mb-1">Nama Penandatangan</p>
                <v-text-field
                    v-model="searchFormBatch.nama_penandatangan"
                    placeholder="Nama Penandatangan"
                    dense
                    outlined
                />
                </div>
                <div class="col-3">
                <p class="label font-weight-bold mb-1">Nomor Batch</p>
                <v-text-field
                    outlined
                    placeholder="Nomor Batch"
                    clearable
                    dense
                    v-model="searchFormBatch.batch_name"
                /> 
                </div>
                <div class="col-3">
                <p class="label font-weight-bold mb-1">Tanggal Pengajuan</p>
                <v-text-field
                    type="date"
                    outlined
                    clearable
                    dense
                    v-model="searchFormBatch.tanggal_pengajuan"
                /> 
                </div>
            </div>
            <div style="height: 80px" class="form-input row">
                <div class="col-4">
                <p class="label font-weight-bold mb-1">Jenis Dokumen</p>
                <v-autocomplete
                    :items="filteredJenisDokumen"
                    :item-text="item => item.nama"
                    :item-value="item => item.id"
                    no-data-text="Tidak ada data"
                    placeholder="Pilih Jenis Dokumen"
                    clearable
                    dense
                    outlined
                    v-model="searchFormBatch.id_jenis_dokumen"
                    @keydown.enter.prevent
                ></v-autocomplete>
                </div>
                <div class="col-4">
                <p class="label font-weight-bold mb-1">Status Dokumen</p>
                <v-select
                    :items="filteredStatusDokumen"
                    :item-text="item => item.nama"
                    :item-value="item => item.id"
                    no-data-text="Tidak ada data"
                    placeholder="Pilih Status Dokumen"
                    clearable
                    dense
                    outlined
                    v-model="searchFormBatch.id_status_dokumen"
                    @keydown.enter.prevent
                ></v-select>
                </div>
                <div class="col-4">
                <p class="label font-weight-bold mb-1"><br></p>
                <v-btn
                    color="primary"
                    class="mr-4"
                    @click="searchDokumenBatch()"
                >
                    Cari
                </v-btn>
                </div>
            </div>
            </esign-filter-panel>
            <br>
        </form>
        <v-card>
            <div class="col-8">
            <v-text-field
                v-model="searchBatch"
                class="esign-table-search"
                prepend-inner-icon="mdi-magnify"
                label="Cari di tabel"
                outlined
                dense
                clearable
                single-line
                hide-details
              ></v-text-field>
            </div>
    
            <v-data-table
                :headers="filteredHeadersBatch"
                :search="searchBatch"
                :items="itemsBatch"
                no-results-text="Data tidak ditemukan"
                no-data-text="Tidak ada data"
                class="elevation-1"  
                :options.sync="optionsBatch" 
                hide-default-footer  
            >
              <template v-slot:footer="{ props, on }">
                <esign-table-footer
                :pagination="props.pagination"
                :options="props.options"
                @update:options="on['update:options']"
                />
              </template>
              <template v-slot:item.status_dokumen="{ item }">
                <esign-status-tag :value="item.status_dokumen" />
              </template>
                <template
                    v-for="header in filteredHeadersBatch.filter((header) =>
                    header.hasOwnProperty('formatter')
                    )"
                    v-slot:[`item.${header.value}`]="{ header, value }"
                >
                    {{ header.formatter(value) }}
                </template>
                <template v-slot:item.action="{ item }">
                <v-row> 
                    <v-btn class="mx-1 mt-1 mb-1" style="margin:auto" x-small color="primary" dark @click="detailBatch(item)"><v-icon small class="mr-1"> mdi-eye </v-icon>Detail</v-btn>
                </v-row>
                </template>
            </v-data-table> 
        </v-card>
        
        
        <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="8000" :top="true">
          {{ snackbarText }}
          <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        </material-card>
    </v-container>
  </template>

<script>
import rememberListState from "@/mixins/rememberListState";
import { apiServer } from "../../setup-axios";
// import Paginate from 'vuejs-paginate';
var moment = require('moment');
export default {
  mixins: [rememberListState],
  // filters/search/page kept when returning from a detail page
  rememberState: ["tab", "searchBatch", "searchFormBatch", "optionsBatch", "nomor_halaman", "totalDataBatch"],
  data: () => ({
    tab:null,
    // search: "",
    searchBatch: "",
    snackbar: false,
    snackbarText: "",
    snackbarColor: "",
    isLoading: true, 
    jenisDokumens: [],
    statusDokumens: [],
    // items: [],
    itemsBatch: [],
    // headers: [],
    // searchForm: {
    //     username_pengaju_login: "",
    //     id_penandatangan_login: -1,
    //     nama_penandatangan: "",
    //     username_pengaju: "",
    //     nomor_surat: "",
    //     tanggal_pengajuan: null,
    //     id_jenis_dokumen: -1,
    //     id_status_dokumen: 3
    // },
    searchFormBatch : {
        username_pengaju_login: "",
        id_penandatangan_login: -1,
        nama_penandatangan: "",
        username_pengaju: "",
        batch_name: "",
        tanggal_pengajuan: null,
        id_jenis_dokumen: -1,
        id_status_dokumen: 1,
        organisasi: -1
    },
    // options: {},
    optionsBatch: {},
    // totalData: 0,
    totalDataBatch: 0,
    tgl:null, 
    peran: "",
    user: null,
    nomor_halaman: 1,
    getDataSource: "search",
    // sortOrder: 'asc',
    // sortBy: 'tanggal_pengajuan',
  }),
//   components: {
//     Paginate
//   },
  computed: {
    filteredJenisDokumen(){
        return this.jenisDokumens.filter(item => item.status)
    },
    filteredStatusDokumen(){
        return this.statusDokumens.filter(item => item.id != 5)
    },
    // filteredHeaders() {
    //   const headers = [
    //     { text: "Nomor Pengajuan", value: "nomor_pengajuan" },
    //     { text: "Tanggal Pengajuan", value: "tanggal_pengajuan", sortable: true, formatter: (x) => (x ? moment.utc(x).locale("id").format('DD-MM-YYYY HH:mm:ss') : null), },
    //     { text: "Nomor Surat", value: "nomor_surat" },
    //     { text: "Jenis Dokumen", value: "nama_jenis_dokumen"},
    //     { text: "Username Pengaju", value: "username_pengaju"},
    //     { text: "Status", value: "status_dokumen"},
    //     { text: "Aksi", align:"center", value: "action", sortable: false}
    //   ]
    //   return headers
    // },
    filteredHeadersBatch() {
      const headers = [ 
        { text: "Nama Batch", value: "batch_name" },
        { text: "Tanggal Pengajuan", value: "tanggal_pengajuan", sortable: true, formatter: (x) => (x ? moment.utc(x).locale("id").format('DD-MM-YYYY HH:mm:ss') : null), },
        { text: "Jenis Dokumen", value: "nama_jenis_dokumen"},
        { text: "Nama Organisasi", value: "nama_organisasi"},
        { text: "Source", value: "source"},
        { text: "Username Pengaju", value: "username_pengaju"},
        { text: "Status", value: "status_dokumen"},
        { text: "Aksi", align:"center", value: "action", sortable: false}
      ]
      return headers
    }
  },
  created() {
    this.peran =localStorage.getItem("currentPeran"),
    this.user= JSON.parse(localStorage.getItem("user"))
    if (this.$store.state.snackbar.snackbarText != null) {
      this.showMessage()
    }
    this.getDropdownJenisDokumen()
    this.getDropdownStatusDokumen()
    // paging/sorting is done by the table itself, so the list is loaded once
    this.getDataBatch()
    // console.log(localStorage.getItem("currentPeran"));
  },
  methods: {
    // getData() {
    //   this.isLoading = true;
    //   console.log("search form", JSON.stringify(this.searchForm));
    //   let tanggal_pengajuan = null
    //   if (this.searchForm.tanggal_pengajuan) {
    //     tanggal_pengajuan = moment(this.searchForm.tanggal_pengajuan).format('DD-MM-YYYY')
    //   }
    //   if (this.peran=='A03') {
    //     this.searchForm.id_penandatangan_login = this.user.id
    //   }
    //   if (this.peran=='A02') {
    //     this.searchForm.username_pengaju_login = this.user.username
    //   }
    //   if (this.getDataSource == "search") {
    //     this.totalData = 0
    //   }
    //   apiServer
    //     .get("/arsip/arsip_list", {
    //       params: {
    //         nomor_surat: this.searchForm.nomor_surat,
    //         username_pengaju: this.searchForm.username_pengaju,
    //         nama_penandatangan: this.searchForm.nama_penandatangan,
    //         id_jenis_dokumen: this.searchForm.id_jenis_dokumen,
    //         tanggal_pengajuan: tanggal_pengajuan,
    //         id_status_dokumen: this.searchForm.id_status_dokumen,
    //         id_penandatangan_login: this.searchForm.id_penandatangan_login,
    //         username_pengaju_login: this.searchForm.username_pengaju_login,
    //         nomor_halaman: this.nomor_halaman,
    //         total_data: this.totalData,
    //       }
    //     })
    //     .then(response => {
    //       this.isLoading = false;
    //       this.items = response.data.data;
    //       this.totalData = response.data.total
    //       if (this.getDataSource == "search") {
    //         this.nomor_halaman = 1
    //       }
    //       this.getDataSource = ""
    //     })
    //     .catch(error => {
    //       console.log("There was an error:", error.response); // Logs out the error
    //       this.isLoading = false;
    //     });
    // },
    getDropdownJenisDokumen() {
      apiServer
        .get("/arsip/dropdown_jenis_dok")
        .then(response => {
          this.jenisDokumens = response.data.data;
        })
        .catch(error => {
          console.log("There was an error:", error.response.data.message); // Logs out the error
        });
    },
    getDropdownStatusDokumen() {
      apiServer
        .get("/arsip/dropdown_status_dok")
        .then(response => {
          // console.log("status: "+ JSON.stringify(response.data.data))
          this.statusDokumens = response.data.data;
        })
        .catch(error => {
          console.log("There was an error:", error.response.data.message); // Logs out the error
        });
    },
    getDataBatch() { 
      console.log("searchFormBatch", JSON.stringify(this.searchFormBatch));
      let tanggal_pengajuan = null
      if (this.searchFormBatch.tanggal_pengajuan) {
        tanggal_pengajuan = moment(this.searchFormBatch.tanggal_pengajuan).format('DD-MM-YYYY')
      }
      if (this.peran=='A03') {
        this.searchFormBatch.id_penandatangan_login = this.user.id
      }
      if (this.peran=='A02') {
        this.searchFormBatch.username_pengaju_login = this.user.username
      } 
      apiServer
        .get("/batch/list", {
          params: {
            batch_name: this.searchFormBatch.batch_name,
            username_pengaju: this.searchFormBatch.username_pengaju,
            nama_penandatangan: this.searchFormBatch.nama_penandatangan,
            id_jenis_dokumen: this.searchFormBatch.id_jenis_dokumen,
            tanggal_pengajuan: tanggal_pengajuan,
            id_status_dokumen: this.searchFormBatch.id_status_dokumen,
            id_penandatangan_login: this.searchFormBatch.id_penandatangan_login,
            username_pengaju_login: this.searchFormBatch.username_pengaju_login,
            id_organisasi: this.searchFormBatch.organisasi,
          }
        })
        .then(response => { 
          this.itemsBatch = response.data.data;
          this.totalDataBatch = response.data.total 
        })
        .catch(error => {
          console.log("There was an error:", error.response); // Logs out the error 
        });
    },
    showSnackbar(color, message) {
      console.log("snack " + color + " - " + message);
      this.snackbar = true;
      this.snackbarText = message;
      this.snackbarColor = color;
    },
    showMessage () {
      this.showSnackbar(
          this.$store.state.snackbar.snackbarColor,
          this.$store.state.snackbar.snackbarText
      )
      this.$store.dispatch('setSnackbar', {
        snackbarColor: null,
        snackbarText: null,
      })
    },
    // searchDokumen(){
    //   console.log("search"+JSON.stringify(this.searchForm))
    //   // this.search = ""
    //   if (!this.searchForm.id_jenis_dokumen) {
    //     this.searchForm.id_jenis_dokumen = -1
    //   }
    //   if (!this.searchForm.id_status_dokumen) {
    //     this.searchForm.id_status_dokumen = -1
    //   }
    //   this.options.page = 1
    //   this.getDataSource = "search"
    //   this.getData()
    // },
    // detailItem(item) {
    //   this.$router.push('/dokumen/detail/'+item.id_arsip);
    // },
    searchDokumenBatch(){
    //   console.log("searchFormBatch with Form"+JSON.stringify(this.searchFormBatch))
      if (!this.searchFormBatch.id_jenis_dokumen) {
        this.searchFormBatch.id_jenis_dokumen = -1
      }
      if (!this.searchFormBatch.id_status_dokumen) {
        this.searchFormBatch.id_status_dokumen = -1
      } 
      this.searchBatch = ""
      this.optionsBatch.page = 1
      this.getDataBatch()
    },
    detailBatch(item) {
      this.$router.push('/batch/detail/'+item.id_batch);
    }
  }
};
</script>